/*
  This is a promise wrapper which will not trigger promise callbacks when in unmounted component
*/
import { AVAILABLE_TRIAL_DAYS } from './constants'
// import { getSearchString } from './hooks'

//
// export const getGobackPath = (locationSearch: string): string => {
//   console.log(locationSearch)
//   const searchParams = new URLSearchParams(locationSearch)
//   // const allRoutes = Object.values(routes)
//   const goBackPath = searchParams.get('goback')
//   // const nextPath = goBackPath && allRoutes.includes(goBackPath) ? goBackPath : routes.find
//   const nextPath = goBackPath ? goBackPath : routes.find

//   return nextPath
// }

// export const getPopupLocation = (path: string, searchObject?: object): object => {
//   const pathname = path
//   const search = getSearchString('', searchObject)

//   return { pathname, search }
// }

export const makeSubscribable = promise => {
  return {
    subscribe: (onSucces, onError, onComplete) => {
      let subscribed = true

      promise
        .then(data => {
          if (subscribed) {
            onSucces(data)
          }
        })
        .catch(error => {
          if (subscribed) {
            onError(error)
          }
        })
        .finally(() => {
          if (subscribed && onComplete) {
            onComplete()
          }
        })

      return () => {
        subscribed = false
      }
    },
  }
}

export const availableTrialDays = registeredDate => {
  const currentDate = new Date()
  const diff = currentDate.getDate() - registeredDate.getDate()
  return AVAILABLE_TRIAL_DAYS - diff
}

export const getRemainingTriadDays = user => {
  if (user.accessPeriodEnd === null) return 7

  const endDate = user.accessPeriodEnd
  const now = new Date()
  const delta = endDate.getTime() - now.getTime()
  const days = delta / 1000 / 60 / 60 / 24
  const rounded = Math.floor(days)

  return rounded
}

export const formatPhoneNumber = number => {
  var match = number.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`
  }
  return null
}

// https://stackoverflow.com/questions/106179/regular-expression-to-match-dns-hostname-or-ip-address
// TODO: remove disable
// eslint-disable-next-line no-useless-escape
// const validHostnameRegex =
//   /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-/]*[A-Za-z0-9])$/

export const truncateUrl = url => {
  return url
    .replace('https://', '')
    .replace('http://', '')
    .replace(/^www\./, '')
    .replace('/', '')
}

export const makeExternalUrl = url => `//${truncateUrl(url)}`

class Log {
  silent = false

  constructor() {
    const env = process.env['REACT_APP_ENV']
    if (env === 'dev' || env === 'test') {
      this.silent = false
    }
  }

  info(...args) {
    if (!this.silent) {
      console.log(...args)
    }
  }
}

export const log = new Log()

export const validateEmail = email => {
  return email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
}
